import { AssessmentProgress, getLevelColor } from '../../types/assessment'

interface ProgressBarProps {
  progress: AssessmentProgress
  showLevel?: boolean
}

export function ProgressBar({ progress, showLevel = true }: ProgressBarProps) {
  return (
    <div className="w-full">
      {/* Progress info */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-gray-600">
          Question {progress.questions_answered}
        </span>
        {showLevel && (
          <span
            className={`px-2 py-0.5 text-xs font-medium text-white rounded-full ${getLevelColor(
              progress.estimated_level
            )}`}
          >
            {progress.estimated_level}
          </span>
        )}
      </div>

      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${Math.min(100, progress.progress_percent)}%` }}
        />
      </div>

      {/* Progress percentage */}
      <div className="flex justify-end mt-1">
        <span className="text-xs text-gray-500">{progress.progress_percent}% complete</span>
      </div>
    </div>
  )
}
